var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTrashFilled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8 2.7H11.4V1.2C11.4 0.538125 10.8619 0 10.2 0H4.2C3.53812 0 3 0.538125 3 1.2V2.7H0.6C0.268125 2.7 0 2.96813 0 3.3V3.9C0 3.9825 0.0675 4.05 0.15 4.05H1.2825L1.74563 13.8563C1.77562 14.4956 2.30437 15 2.94375 15H11.4562C12.0975 15 12.6244 14.4975 12.6544 13.8563L13.1175 4.05H14.25C14.3325 4.05 14.4 3.9825 14.4 3.9V3.3C14.4 2.96813 14.1319 2.7 13.8 2.7ZM10.05 2.7H4.35V1.35H10.05V2.7Z",
    fill: "#7257F0"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashFilled);
export default __webpack_public_path__ + "static/media/TrashFilled.233c302c39fa1f82a17e7c57b175f643.svg";
export { ForwardRef as ReactComponent };